/**
 *
 * Actions Service Selectors
 *
 */

import { createSelector } from 'reselect/lib';
import { NAMESPACE } from './constants';

const selectService = (state) => state ? state[NAMESPACE] : {};

const selectStatus = createSelector(selectService, (service) => service.status);

const selectResult = createSelector(selectService, (service) => {
  const { result } = service;
  return result;
});

const selectError = createSelector(selectService, (service) => service.error);

export {
  selectStatus,
  selectResult,
  selectError,
};



// WEBPACK FOOTER //
// ./src/services/actions/selectors.js